import React, { useContext } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Spinner from 'components/Spinner/desktop';
import { ModalContext } from 'components/ModalProvider/ModalProvider';

import CashbackHeader from './CashbackHeader';
import CashbackList from './CashbackList';
import CashbackEditor from './CashbackEditor';
import useCashbackList from '../../../model/useCashbackList';

import './CashbackCreation.scss';

const b = block('cashback-creation-desktop');

const CashbackCreation = () => {
  const authData = useSelector(s => s.auth);
  const actionProcessing = useSelector(s => s.cashback.actionProcessing);
  const { values, handlers } = useCashbackList();
  const { openModal } = useContext(ModalContext);

  const handleCreateClick = () => {
    openModal({
      content: <CashbackEditor />,
      title: 'create cashback',
    });
  };

  return (
    <article className={b()}>
      <Spinner isLoading={actionProcessing} />
      <CashbackHeader onCreateClick={handleCreateClick} />
      <CashbackList />
    </article>
  );
};

export default CashbackCreation;
